'use client'

import CareersPositionVM from 'clients/strapi/models/CareersPositionVM'
import Button from 'components/Buttons/Button/Button'
import paths from 'constants/paths'
import Link from 'next/link'
import ArrowLeft from 'public/assets/arrow-left.svg'
import ArrowRight from 'public/assets/arrow-right.svg'
import Location from 'public/assets/location.svg'
import { useEffect, useRef, useState } from 'react'
import styles from './MorePositions.module.scss'

type MorePositionsProps = {
  positions: CareersPositionVM[]
  page: 'careers' | 'position'
}

const MorePositions = ({ positions, page }: MorePositionsProps) => {
  const positionRef = useRef<HTMLDivElement>(null)
  const [positionsNotOverflowing, setPositionsNotOverflowing] = useState(false)

  function scroll(direction: number) {
    if (direction > 0) {
      positionRef.current?.scrollTo({ left: positionRef.current.scrollWidth, behavior: 'smooth' })
    } else {
      positionRef.current?.scrollTo({ left: 0, behavior: 'smooth' })
    }
  }

  useEffect(() => {
    if (positionRef.current) {
      setPositionsNotOverflowing(positionRef.current.scrollWidth <= positionRef.current.clientWidth)
    }
  }, [])

  return (
    <section id='positions' className={styles.container}>
      <div className={styles['header-cta'] + ' ' + styles[page]}>
        {page === 'position' ? (
          <>
            <span>Discover Your Next Role</span>
            <Link href={paths.careers}>
              <Button>Explore Careers</Button>
            </Link>
          </>
        ) : (
          <>
            <span className={styles.title}>Find your spot on our team</span>
            <span className={styles.text}>We’re always looking for talented, passionate people—check out our open roles and see where you fit in!</span>
          </>
        )}

        {positions.length > 2 && (
          <div className={styles.arrows + ' ' + styles[page]}>
            <ArrowLeft onClick={() => scroll(-1)} />
            <ArrowRight onClick={() => scroll(1)} />
          </div>
        )}
      </div>

      <div ref={positionRef} className={styles.positions + ' ' + styles[page] + (positionsNotOverflowing ? ' ' + styles['not-overflowing'] : '')}>
        {positions.map((position) => (
          <Link href={paths.careersPosition(position.slug)} key={position.id} className={styles.position}>
            <div className={styles.head}>
              <span className={styles.title}>{position.title}</span>
              <span className={styles.location}>
                <Location />
                {position.location}
              </span>
            </div>
            <Button variety='tertiary-ghost'>Find Out More</Button>
          </Link>
        ))}
      </div>
    </section>
  )
}

export default MorePositions
